import Vue from 'vue'
import App from './App.vue'
import store from './store'
import { isMobile } from 'mobile-device-detect'

import BuildPanorama from './index'
import BuildPanoramaStructure from '@/structure'

Vue.use(BuildPanorama, {
  structure: BuildPanoramaStructure,
  utils: { isMobile },
  _store: store
})

if (process.env.VUE_APP_CI_COMMIT) {
  window.VUE_APP_CI_COMMIT = process.env.VUE_APP_CI_COMMIT
}

Vue.config.productionTip = false

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')
